import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, Select, Tabs, Tooltip } from "antd";

import { useMediaQuery } from "react-responsive";
import { DownCircleOutlined } from "@ant-design/icons";
import { Images } from "../../../Controller";

import { useDispatch, useSelector } from "react-redux";
import {
  setHeadings,
  setSubHeadings,
  setselectedTab,
} from "../../../Store/B2bslice";
import { Education } from "../../../Assets/education";
import { ThemeColor } from "../../../Theme/theme";
import { Fasttag } from "../../../Assets/fastag";
import { Mobile_Prepaid } from "../../../Assets/mobile prepaid";
import { Mobile_PostPaid } from "../../../Assets/mobile postpaid";
import { DataCard } from "../../../Assets/datacard_icon";
import { Creditcard } from "../../../Assets/Creditcard";
import { DTH } from "../../../Assets/dth";
import { Electricity } from "../../../Assets/Electricity";
import { Gas_Icon } from "../../../Assets/gas_icon";
import { Water } from "../../../Assets/water_icon";
import { Cable } from "../../../Assets/cable";
import { Club } from "../../../Assets/club";
import { Hospital } from "../../../Assets/hospital";
import { HousingSociety } from "../../../Assets/housing society";
import { Insurance } from "../../../Assets/insurance";
import { Landline } from "../../../Assets/landline";
import { Loan } from "../../../Assets/loan";
import { Municiple_service } from "../../../Assets/municipal service";
import { Subscription } from "../../../Assets/subscription";
import { Municipal_Tax } from "../../../Assets/municipal tax";
import { Lpg_Gas } from "../../../Assets/LPG Gas";
import NotAvailable from "../../../Routes/NotAvailable";
import Entertainment from "../../../Assets/Entertainment";
import Broadband from "../../../Assets/Broadband";
import { useSearchParams } from "react-router-dom";
import CommonBBPS3 from ".";
import {
  getBillerCaregories,
  getBillerCategories,
  getBillerCoverage,
} from "../../../ApiServices/Apifun";
const RechargeAndBill3 = () => {
  const dispatch = useDispatch();
  const [selection, setSelection] = useState("Postpaid");
  const isExtraLargeScreen = useMediaQuery({ minWidth: 1501, maxWidth: 4000 });
  const isLargeScreen = useMediaQuery({ minWidth: 992, maxWidth: 1500 });
  const isMediumScreen = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isSmallScreen = useMediaQuery({ minWidth: 400, maxWidth: 767 });
  const isExtraSmallScreen = useMediaQuery({ minWidth: 250, maxWidth: 500 });
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const [searchParam] = useSearchParams();
  const { TabPane } = Tabs;
  const { Option } = Select;

  const [allproviders, setAllProviders] = useState([]);
  const [coverage, setBillerCoverage] = useState([]);

  const [selectLoading, setSelectLoading] = useState(false);

  // track provider selected for each service
  const [selectedProviders, setSelectedProviders] = useState({});

  // group providers by service_name and keep service_id
  const grouped = useMemo(() => {
    return (allproviders || []).reduce((acc, item) => {
      const svcName = item.name || "Unknown";
      if (!acc[svcName]) {
        acc[svcName] = { id: item.id, providers: [] };
      }
      acc[svcName].providers.push(item);
      return acc;
    }, {});
  }, [allproviders]);

  const handleSelectChange = (serviceName, value) => {
    setSelectedProviders((prev) => ({
      ...prev,
      [serviceName]: value,
    }));
  };

  const getBillerCateg = () => {
    setSelectLoading(true);
    getBillerCategories()
      .then((res) => {
        if (res?.status) {
          setAllProviders(res.data?.data?.data || []);
        } else {
          setAllProviders([]);
        }
      })
      .catch((err) => {
        console.error("getProviders error:", err);
        setAllProviders([]);
      })
      .finally(() => setSelectLoading(false));
  };

  const getBillerCov = () => {
    setSelectLoading(true);
    getBillerCoverage()
      .then((res) => {
        if (res?.status) {
          setBillerCoverage(res.data?.data?.data || []);
        } else {
          setBillerCoverage([]);
        }
      })
      .catch((err) => {
        console.error("getProviders error:", err);
        setAllProviders([]);
      })
      .finally(() => setSelectLoading(false));
  };

  useEffect(() => {
    dispatch(setSubHeadings(""));
    dispatch(setselectedTab("1005"));
    dispatch(setHeadings("Bill Payment 3"));
    getBillerCateg();
    getBillerCov();
  }, []);

  const hasData = Object.keys(grouped).length > 0;

  if (!hasData) return null;
  return (
    <div className="All_services  pz-4 rounded-md mb-5 gap-4  flex-wrap items-center">
      <Tabs type="line" className="p-4 custom-tabs">
        {Object.entries(grouped)
          .sort(([a], [b]) => a.localeCompare(b))
          .map(([serviceName, { id, providers }]) => (
            <TabPane tab={serviceName} key={id}>
              <div className="w-full md:w-1/2 mt-4 bg-white p-4 rounded-lg">
                <p className="font-semibold capitalize text-[18px] mb-2">
                  {serviceName} Payment
                </p>

                {/* Coverage Dropdown */}
                <Select
                  showSearch
                  allowClear
                  placeholder={`Select ${serviceName}`}
                  optionLabelProp="label"
                  className="w-full"
                  value={selectedProviders[serviceName]?.id || undefined}
                  onChange={(value) => {
                    const coverageData = coverage.find((p) => p.id === value);
                    handleSelectChange(serviceName, coverageData);
                  }}
                  loading={selectLoading}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {coverage.map((item) => (
                    <Option key={item.id} value={item.id} label={item.name}>
                      <span className="flex items-center gap-2">
                        {item.name}
                      </span>
                    </Option>
                  ))}
                </Select>

                {selectedProviders[serviceName] ? (
                  memberServices.includes("253") ? (
                    <CommonBBPS3
                      // categoryName={serviceName}
                      categoryId={id}
                      coverage={selectedProviders[serviceName]} //{"id": "IND-ANP","name": "IND-ANP"}
                      categoryName={providers}
                    />
                  ) : (
                    <NotAvailable />
                  )
                ) : (
                  <p className="text-gray-500">
                    Please select a Coverage to continue.
                  </p>
                )}
              </div>
            </TabPane>
          ))}
      </Tabs>
    </div>
  );
};

export default RechargeAndBill3;
